export const lightTheme = {
  main: "#77A2CA",
  darkButton: "#3975AE",
  lightButton: "#C0DAF0",
  buttonText: "#3D6890",
  form: "#ebebeb",
  settings: "#808080",
};

export const darkTheme = {
  form: "#404047",
  formText: "white",
};

export const styleColors = {
  lightBlue: "#E3EDF5",
  paleBlue: "#C0DAF0",
  mainBlue: "#77A2CA",
  medBlue: "#3975AE",
  darkBlue: "#3D6890",
  deepBlue: "#082946",
  lightPeri: "#9394D4",
  periwinkle: "#6667AB",
  lightMint: "#DAFFED",
  mint: "#B5F0D3",
  green: "#ADFC92",
  medGreen: "#8CDD70",
  checkmarkGreen: "#38A169",
  charcoal: "#2D3748",
  mainBlueAlpha300: "rgba(119,162,202,0.16)",
  paleBlueAlpha700: "rgb(192,218,240, 0.64)",
};

export const groupLogos = [
  "#E06C9F",
  "#3975AE",
  "#8CDD70",
  "#2A1E5C",
  "#BA1200",
  "#F18F01",
  "#FF6B6B",
  "#1A535C",
];
